import type { SwagError } from '@atlassian/jira-software-swag/src/common/utils/error/index.tsx';

export const extractTraceId = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	error: Partial<Error | SwagError> & Record<PropertyKey, any>,
): string => String(error?.traceId || error?.networkError?.traceId || '');
